import prStringInvocationModalContainer from './prStringInvocationModalContainer'
import PrStringInvocationModal from './PrStringInvocationModal'

export default prStringInvocationModalContainer(PrStringInvocationModal)
